module.exports = __webpack_public_path__ + "img/MX-C130092A-BS.0bd66f4f.png";